//import * as CarpContent from '../components/Content/Carp/Content';
import * as CarpCustomGraphs from '../components/Graphs/FeralScan';
//import * as CarpMapMarker from '../components/Map/MapMarker';
import * as CarpFooter from '../components/Page/Footer/FooterCarp';
import { ICustomConfiguration } from './ICustomConfiguration';
import { activateAccountMapQueryStringToProps, changePasswordMapQueryStringToProps, siteDetailEventMapQueryStringToProps, siteDetailMapQueryStringToProps, siteDetailShouldRerouteHome } from '../helpers/configurationHelper';
import { DashboardContainerProps } from '../containers/dashboard.container';


export function aggregateData(data, field) {
    let aggregate = data.map((datum) => {
        return {
            key: datum[field],
            count: data
                .filter(o => o[field] === datum[field])
                .reduce(((sum, o) => sum + 1), 0),
            value: data
                .filter(o => o[field] === datum[field])
                .reduce(((sum, o) => sum + o.value), 0)
        };
    });

    let reduced = aggregate.reduce(function (a, d) {
        if (a.filter(o => o.key === d.key).length === 0) {
            d.mean = d.value ? d.count > 120 ? (d.value / d.count).toFixed(2) : (d.value / d.count).toFixed(1) : undefined;
            a.push(d);
        }
        return a;
    }, []);

    return reduced;
}

export const CustomConfiguration: ICustomConfiguration = {
    productName: "carp",

    // component mappings
    MapMarker: undefined,//CarpMapMarker.default,
    CustomGraphs: CarpCustomGraphs.default,
    ContentPage: undefined, // CarpContent.default,
    PageFooter: CarpFooter.default,
    
    enableBrowserGeolocation: false,
    defaultMapTypeId: 'roadmap',

    // host mappings
    googleApi: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAWpqvFDJ_faZ_OYjsGicI0_epY-NsLfDY&libraries=geometry,places,visualization',
    markerHost: process.env.NODE_ENV !== "production" ? "http://localhost:62113" : "http://carpdashboard.newtongreen.com",

    // constants
    defaultPageTitle: "National Carp Survey",
    defaultBannerName: "Have you seen Carp in your local waterways?",
    defaultMapLatitude: -25,
    defaultMapLongitude: 134,
    defaultRoute: "/carp/content",
    defaultTab: "CONTENT",

    pageTitleAppend: " | National Carp Survey",
    footerLogo: require("../assets/img/feralscan/footer-logo.png"),

    // localisation
    noSummaryData: "No data returned for the selected settings. Increase the Date Period",
    pleaseWait: "please wait, loading data",

    tabs: [
        {
            type: "SITE",
            route: "sites",
            bannerName: undefined,
            pageTitle: undefined,
            showSideBar: true,
            showContentHeader: true,
            showFooter: true,
            showHeader: true,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "ADMIN",
            route: "settings",
            bannerName: undefined,
            pageTitle: undefined,
            showSideBar: true,
            showContentHeader: false,
            showFooter: true,
            showHeader: true,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "USER_PROFILE",
            route: "user",
            bannerName: "Have you seen Carp in your local waterways?",
            pageTitle: "Have you seen Carp in your local waterways?",
            showSideBar: false,
            showContentHeader: false,
            showFooter: true,
            showHeader: true,
            sidebarLink: {
                label: "USER PROFILE",
                icon: require("../assets/img/map.svg"),
                hiddenOnTabs: ["SUMMARY", "SURVEY", "MAP"],
                hiddenWhenUnauthenticated: false
            },
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "PASSWORD_RESET",
            route: "passwordreset",
            bannerName: "Password Reset",
            pageTitle: "Password Reset",
            showSideBar: false,
            showContentHeader: false,
            showFooter: true,
            showHeader: true,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: changePasswordMapQueryStringToProps,
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "ACTIVATE_ACCOUNT",
            route: "activateaccount",
            bannerName: "Activate Account",
            pageTitle: "Activate Account",
            showSideBar: false,
            showContentHeader: false,
            showFooter: true,
            showHeader: true,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: activateAccountMapQueryStringToProps,
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        },
        {
            type: "SITE_DETAIL",
            route: "site-detail",
            bannerName: undefined,
            pageTitle: undefined,
            showSideBar: true,
            showContentHeader: true,
            showFooter: true,
            showHeader: true,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: siteDetailMapQueryStringToProps,
            pushIntoQueryString: () => {
                return undefined;
            },
            shouldRerouteHome: siteDetailShouldRerouteHome
        },
        {
            type: "SITE_DETAIL_EVENT",
            route: "site-detail-event",
            bannerName: undefined,
            pageTitle: undefined,
            showSideBar: true,
            showContentHeader: true,
            showFooter: true,
            showHeader: true,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: siteDetailEventMapQueryStringToProps,
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: () => {
                return false;
            } /*siteDetailEventShouldRerouteHome */
        },
        {
            type: "SURVEY",
            route: "survey",
            showSideBar: false,
            showContentHeader: false,
            showFooter: true,
            showHeader: true,
            bannerName: "Survey",
            pageTitle: "Survey",
            sidebarLink: {
                label: "SURVEY",
                icon: require("../assets/img/data.svg"),
                hiddenOnTabs: ["MAP", "SUMMARY", "USER_PROFILE"],
                hiddenWhenUnauthenticated: false
            },
            needsAuthentication: true,
            mapQueryStringToProps: siteDetailEventMapQueryStringToProps,
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: () => {
                return false;
            }
        },
        {
            type: "CONTENT",
            route: "content",
            showSideBar: false,
            showContentHeader: false,
            showFooter: true,
            showHeader: true,
            bannerName: undefined,
            pageTitle: undefined,
            sidebarLink: undefined,
            needsAuthentication: false,
            mapQueryStringToProps: () => {
                return {}
            },
            pushIntoQueryString: () => {
                return undefined
            },
            shouldRerouteHome: (props: DashboardContainerProps, prevProps: DashboardContainerProps) => {
                return undefined
            }
        }
    ], // Order matters. First is the default
    filterTitle: "DISPLAY SETTINGS",
    filterDisableInterface: true,
    defaultFilterDays: 30,
    filterPrintShow: false,
    filterBackShow: true,

    /* BANNER SETTINGS */
    showBannerLogin: false,
    showBannerLoginForm: true,
    showBannerLogout: true,
    showBannerProfile: false,

    totalsGraphTitle: "Data Over Time",
    summaryGraphTitle: "Summary",
    classificationL1: "Species",
    classificationL2: "Types",

    enableCreateNewSite: true,
    enableAnonymousCreation: true,
    defaultGraphColors: ['#63AE6E', '#CEDFEE', '#0F3A5F', '#CC9652', '#FFC00F', '#E6A2A0', '#E4DBCF', '#CCCC00', '#D1E6B4', '#9A9663', '#7A7663'],

    defaultMapMarkerZoom: 16,
    defaultMapType: "clustered",

    donutCharts: false,

    IsMarkerActive: undefined,
    GetSeasonalQuarterDate: undefined,
    GetSeasonName: undefined,
    
    aggregateData: aggregateData,

    mapStyles: [
        {
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#bdbdbd"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dadada"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#c9c9c9"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        }
    ]
}